import templateUrl from "emun.auth/reset-password/reset-password.htm";
import controller from "emun.auth/reset-password/reset-password.controller";

export default {
  bindings: {
    errors: "=?",
    emailLabel: "@",
    emailPlaceholder: "@",
    submitLabel: "@",
    callbackUrl: "@",
    onSuccess: "&",
    onFail: "&",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
